<div class="history-log-section">
  <label class="fw-bold">{{ label }}</label>

  <div class="history-log-box" [style.height.px]="height">
    @if (isLoadingHistoryLogs) {
      <span class="history-log-placeholder">Loading history logs...</span>
    } @else if (!historyLogEntries.length) {
      <span class="history-log-placeholder">No history logs available.</span>
    } @else {
      @for (entry of historyLogEntries; track $index) {
        <div class="history-log-entry">
          <div class="history-log-header">
            <span class="history-log-author">{{ entry.author }}</span>
            @if (entry.logTime) {
              <span class="history-log-time">{{ entry.logTime }}</span>
            }
          </div>
          <div class="history-log-message">{{ entry.message }}</div>
        </div>
      }
    }
  </div>
</div>
